export type MobileAppTab =
  | "Categories"
  | "Products"
  | "Orders"
  | "Service Types"
  | "Requests";

export const MOBILE_APP_TABS: Array<{ id: MobileAppTab; label: string }> = [
  { id: "Categories", label: "Categories" },
  { id: "Products", label: "Products" },
  { id: "Orders", label: "Orders" },
  { id: "Service Types", label: "Service Types" },
  { id: "Requests", label: "Service Requests" },
];

export const isShopTab = (tab: MobileAppTab) =>
  tab === "Categories" || tab === "Products" || tab === "Orders";

export const isServicesTab = (tab: MobileAppTab) =>
  tab === "Service Types" || tab === "Requests";
